import React from 'react';

interface ButtonGroupProps<T extends string> {
    buttons: {value: T; label: string; icon?: JSX.Element; dataCy?: string}[];
    value: T;
    onChange: (value: T) => void;
}

function ButtonGroup<T extends string>({buttons, value, onChange}: ButtonGroupProps<T>): JSX.Element {
    return (
        <div className="c-buttonGroup">
            {buttons.map((btn) => (
                <button
                    type="button"
                    key={btn.value}
                    onClick={() => onChange(btn.value)}
                    className={`c-buttonGroup__btn ${btn.value === value ? 'c-buttonGroup__btn--active' : ''}`}
                    data-cy={btn.dataCy}
                >
                    <div className="u-flex u-v-center u-h-center">
                        <div>{btn.label}</div>
                        {btn.icon && <div className="u-ml-1 u-lineHeight-0">{btn.icon}</div>}
                    </div>
                </button>
            ))}
        </div>
    );
}

export default ButtonGroup;
